// extracted by mini-css-extract-plugin
export default {"modal":"SubMenuEgresos_modal__QxqTA","botones":"SubMenuEgresos_botones__XRgyy"};